import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { CMS_PRODUCT_LIST_CONVERTER_TOKEN, CmsProductListConverter } from './cms-product-list.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        cmsProductListFeature: {
          module: () => import('./cms-product-list.module').then((m) => m.CmsProductListModule),
          cmsComponents: ['productlist']
        },
      }
    }),
    {
      provide: CMS_PRODUCT_LIST_CONVERTER_TOKEN,
      useExisting: CmsProductListConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        productlist: CMS_PRODUCT_LIST_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class CmsProductListFeatureModule {}
